// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__14UM5","author":"Table_author__zk6xJ","authorImage":"Table_authorImage__3xbHt","unreadRow":"Table_unreadRow__2yUn7"};